<template>
<div class="modal-card">
  <header class="modal-card-head">
    <p class="modal-card-title">{{propItem ? "Edit Item" : "Add Item"}}</p>
  </header>

  <section class="modal-card-body">

      <b-field label="Name:">
        <b-input :disabled="role === 'viewer'" type="text" v-model="name" placeholder="Item Name"></b-input>
      </b-field>

      <b-field v-if="bNameError" style="color: red">
        Please enter name.
      </b-field>

      <b-field label="Description:">
        <b-input :disabled="role === 'viewer'" type="text" v-model="description" placeholder="Item Description"></b-input>
      </b-field>

      <b-field label="Price:" v-if="isSpecialOffer">
          <b-numberinput :disabled="role === 'viewer'" type="is-info" controls-position="compact" controls-rounded v-model="price" min="1"></b-numberinput>
      </b-field>

      <b-field v-if="resourceName.length > 0 && imageUrl.length > 0">
        <b>Currently uploaded file:</b> {{resourceName}}
      </b-field>

      <b-modal :active.sync="isImageModalActive" scroll="keep">
        <p class="image">
          <img :src="imageUrl" >
        </p>
      </b-modal>

      <b-field v-if="resourceName.length > 0 && imageUrl.length > 0">
        <img :src="imageUrl" width="275" @click="isImageModalActive=true" style="cursor:pointer">
      </b-field>

      <b-field label="Choose image file to upload:">
      </b-field>
        <b-button :disabled="role === 'viewer'" icon-left="file-upload" type="is-primary" outlined @click="addFile()">
          Local storage
        </b-button>
        <b-button :disabled="role === 'viewer'" icon-left="file" type="is-success" outlined @click="openLibrary()">
          Existing resources
        </b-button>
        <b-button :disabled="role === 'viewer'" icon-left="trash" type="is-danger" outlined @click="openBin()">
          {{isSpecialOffer ? 'Special offers archive' : 'Menus archive'}}
        </b-button>

      <b-field v-if="bFileError" style="color: red">
        {{bFileMessage}}
      </b-field>
<br>
      <b-field v-if="itemFiles.length > 0">
        Chosen file: {{itemFiles[0].name}}
      </b-field>
  </section>

  <footer class="modal-card-foot">
    <b-button :disabled="role === 'viewer'" type="is-info" @click="submitItem">Save</b-button>
    <b-button type="is-light" @click="$parent.close()">Cancel</b-button>
    <input style="display: none" @change="fileUploaded" id="fileSelect" name="fileSelect" type="file">
  </footer>

</div>
</template>

<script>
import PhotoLibrary from '@/components/menu/items/PhotoLibrary'
import MenusBin from '@/components/menu/items/MenusBin'

export default {
  name: 'MenuItemAddEdit',
  props: ['propItem', 'propId', 'propParentFn', 'isSpecialOffer', 'propParent', 'menId'],
  data: () => {
    return {
      name: '',
      description: '',
      resourceName: '',
      resourceSize: null,
      price: 1,
      itemFiles: [],
      bFileError: false,
      bFileMessage: '',
      bNameError: false,
      imageUrl: '',
      isImageModalActive: false,
      toRemove: [],
      toArchive: [],
      deleteFromBinItem: null,
      sizeOfResource: 0,
      nameOfResource: null,
      items: [],
      menuRef: {},
      sizeMinus: null,
      alreadyUploadedFile: null,
      newUpload: false,
      oldItem: null
    }
  },
  computed: {
    role () {
      return this.$store.state.role
    }
  },
  mounted: function () {
    this.globalLogger('MOUNTED')
    if (this.menId !== undefined) {
      if (this.isSpecialOffer) {
        this.menuRef = Object.assign({}, this.$store.getters.getSpecialOffer(this.menId))
      } else {
        this.menuRef = Object.assign({}, this.$store.getters.getMenu(this.menId))
      }
      if (this.menuRef.items) {
        this.items = [...this.menuRef.items.filter(x => x)]
      }
    }
    if (this.propItem) {
      this.oldItem = Object.assign({}, this.propItem)
      this.globalLogger(this.oldItem, 'OLD ITEM na pocetok')
      this.name = this.propItem.name
      this.description = this.propItem.description
      if (this.propItem.price) {
        this.price = parseInt(this.propItem.price.split(' ')[0])
      }
      if (this.propItem.file) {
        this.globalLogger('this.propItem.file', this.propItem.file)
        this.itemFiles = [this.propItem.file]
        this.alreadyUploadedFile = [this.propItem.file]
      }
      if (this.propItem.resourceName) {
        this.resourceName = this.propItem.resourceName
      }
      if (this.propItem.resourceSize) {
        this.resourceSize = this.propItem.resourceSize
      }
      if (this.propItem.imageUrl) {
        this.imageUrl = this.propItem.imageUrl
      }
    }
  },
  methods: {
    openLibrary () {
      if (this.role !== 'viewer') {
        this.$buefy.modal.open({
          parent: this,
          component: PhotoLibrary,
          props: { isSO: this.isSpecialOffer, propParent: this.getFileFromChild },
          hasModalCard: true,
          trapFocus: true,
          onCancel: this.cancelAdd,
          canCancel: ['x']
        })
      }
    },
    openBin () {
      if (this.role !== 'viewer') {
        this.$buefy.modal.open({
          parent: this,
          component: MenusBin,
          props: { isSO: this.isSpecialOffer, propParent: this.getFileFromChildBin },
          hasModalCard: true,
          trapFocus: true,
          onCancel: this.cancelAdd,
          canCancel: ['x']
        })
      }
    },
    getFileFromChild (file) {
      if (this.alreadyUploadedFile !== null) {
        this.newUpload = true
      }
      this.itemFiles = [file]
    },
    getFileFromChildBin (file) {
      if (this.alreadyUploadedFile !== null) {
        this.newUpload = true
      }
      this.globalLogger('GET FILE FROM CHILD BIN', file.size)
      this.sizeMinus = file.size
      this.globalLogger(this.sizeMinus, 'sizeMinus')
      this.itemFiles = [file]
      this.deleteFromBinItem = file.name
      this.globalLogger('del from bin: ', this.deleteFromBinItem)
    },
    addFile () {
      if (this.role !== 'viewer') {
        document.getElementById('fileSelect').click()
      }
    },
    fileUploaded (e) {
      if (this.alreadyUploadedFile !== null) {
        this.newUpload = true
      }
      let files = e.target.files
      this.bFileError = false
      this.itemFiles = [files[0]]
      this.globalLogger(files[0].size, 'SIZE')
      /* if (this.itemFiles[0].type !== 'image/jpeg' && this.itemFiles[0].type !== 'image/png') {
        this.bFileError = true
        this.bFileMessage = 'Incompatible file format! The supported types are .png/.jpg.'
        this.itemFiles = []
      } else if (this.itemFiles[0].size >= 5242880) {
        this.bFileError = true
        this.bFileMessage = 'Resource too big! Maximum resource size is 5 MB.'
        this.itemFiles = []
      } */
    },
    submitItem () {
      if (this.role !== 'viewer') {
        this.globalLogger('submit item')
        this.globalLogger(this.itemFiles[0], 'files[0]')
        this.bNameError = false
        this.bFileError = false
        if (this.name === '') {
          this.bNameError = true
        } else if (this.itemFiles.length === 0 && this.resourceName === '') {
          this.bFileError = true
          this.bFileMessage = 'Please upload an image.'
        } else if (this.itemFiles[0] && this.itemFiles[0].type !== 'image/jpeg' && this.itemFiles[0].type !== 'image/png') {
          this.bFileError = true
          this.bFileMessage = 'Incompatible file format! The supported types are .png/.jpg.'
          this.itemFiles = []
        } else if (this.itemFiles[0] && this.itemFiles[0].size >= 5242880) {
          this.bFileError = true
          this.bFileMessage = 'Resource too big! Maximum image size is 5 MB.'
          this.itemFiles = []
        } else {
          if ((this.itemFiles[0] !== undefined && this.alreadyUploadedFile !== null && this.alreadyUploadedFile[0] !== undefined && this.resourceName !== '' && this.alreadyUploadedFile[0] !== this.itemFiles[0] && !this.newUpload) || (this.itemFiles[0] !== undefined && this.resourceName !== '' && this.alreadyUploadedFile === null)) {
            // this.globalLogger(this.itemFiles[0], this.alreadyUploadedFile[0], 'TUKAAA')
            var isUsed = false
            var brojac = 0
            this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(this.propId) })
            this.globalLogger('items:', this.items)
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i].resourceName === this.resourceName) {
                this.globalLogger('is used is true')
                brojac++
                isUsed = true
              }
            }
            if (isUsed) {
              var mess = null
              if (brojac > 1) {
                mess = 'The previous resource ("' + this.resourceName + '") is also used by other items and will remain in the menu.'
                // this.$buefy.dialog.alert('The resource "' + fileN + '" is being used by other items and will remain in the playlist.')
              } else {
                mess = 'The previous resource ("' + this.resourceName + '") is also used by another item and will remain in the menu.'
              }
              this.$buefy.toast.open({
                duration: 8000,
                message: mess
              })
              let item = {
                name: this.name,
                description: this.description,
                resourceName: this.resourceName,
                userId: this.$store.state.uid
              }
              if (this.isSpecialOffer) {
                item.price = `${this.price} den.`
              }
              if (this.itemFiles[0]) {
                item.file = this.itemFiles[0]
                item.resourceSize = this.itemFiles[0].size
                this.sizeOfResource = this.itemFiles[0].size
                this.nameOfResource = this.itemFiles[0].name
              } else if (this.propItem) {
                if (this.propItem.resourceSize) {
                  item.resourceSize = this.propItem.resourceSize
                  this.globalLogger('resSize', this.propItem.resourceSize)
                }
              }
              if (this.propItem) {
                this.globalLogger('here 1')
                item.imageUrl = this.propItem.imageUrl
                this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem, this.resourceSize, this.resourceName)
              } else {
                this.propParentFn(item, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource)
              }
              this.$parent.close()
            } else {
              this.globalLogger(this.itemFiles[0].name)
              this.$buefy.dialog.confirm({
                message: 'Do you want to delete the previous resource ("' + this.resourceName + '")?',
                cancelText: 'Archive resource',
                confirmText: 'Delete forever',
                type: 'is-danger',
                onConfirm: () => {
                  this.globalLogger('delete resource')
                  this.$buefy.toast.open({
                    duration: 3000,
                    message: 'The previous resource will be deleted on submit.'
                  })
                  this.toRemove.push(this.resourceName)
                  // this.removeMenu(id, isSpecial, true)
                  let item = {
                    name: this.name,
                    description: this.description,
                    resourceName: this.resourceName,
                    userId: this.$store.state.uid
                  }
                  if (this.isSpecialOffer) {
                    item.price = `${this.price} den.`
                  }
                  if (this.itemFiles[0]) {
                    item.file = this.itemFiles[0]
                    item.resourceSize = this.itemFiles[0].size
                    this.sizeOfResource = this.itemFiles[0].size
                    this.nameOfResource = this.itemFiles[0].name
                  } else if (this.propItem) {
                    if (this.propItem.resourceSize) {
                      item.resourceSize = this.propItem.resourceSize
                      this.globalLogger('resSize', this.propItem.resourceSize)
                    }
                  }
                  if (this.propItem) {
                    this.globalLogger('HEERE 2')
                    this.globalLogger(this.sizeOfResource, this.nameOfResource + ' nov')
                    this.globalLogger(this.resourceName, this.resourceSize + ' star')
                    item.imageUrl = this.propItem.imageUrl
                    this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource, this.resourceSize, this.resourceName)
                  } else {
                    this.propParentFn(item, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource)
                  }
                  this.$parent.close()
                },
                onCancel: () => {
                  this.globalLogger('archive resource')
                  this.$buefy.toast.open({
                    duration: 3000,
                    message: 'The previous resource will be archived on submit.'
                  })
                  this.toArchive.push({ 'resName': this.resourceName, 'resSize': this.resourceSize })
                  let item = {
                    name: this.name,
                    description: this.description,
                    resourceName: this.resourceName,
                    userId: this.$store.state.uid
                  }
                  if (this.isSpecialOffer) {
                    item.price = `${this.price} den.`
                  }
                  this.globalLogger('im here')
                  if (this.itemFiles[0]) {
                    item.file = this.itemFiles[0]
                    item.resourceSize = this.itemFiles[0].size
                    this.sizeOfResource = this.itemFiles[0].size
                    this.nameOfResource = this.itemFiles[0].name
                    this.globalLogger('da')
                  } else if (this.propItem) {
                    if (this.propItem.resourceSize) {
                      item.resourceSize = this.propItem.resourceSize
                      this.globalLogger('resSize', this.propItem.resourceSize)
                      this.globalLogger('ne')
                    }
                  }
                  if (this.propItem) {
                    item.imageUrl = this.propItem.imageUrl
                    this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource)
                    this.globalLogger('da 1')
                  } else {
                    this.globalLogger(this.sizeOfResource, this.nameOfResource + ' TUKAA')
                    this.propParentFn(item, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource)
                    this.globalLogger('ne 1')
                  }
                  this.$parent.close()
                }
              })
            }
          } else {
            this.globalLogger('hereee')
            let item = {
              name: this.name,
              description: this.description,
              resourceName: this.resourceName,
              userId: this.$store.state.uid
            }
            if (this.isSpecialOffer) {
              item.price = `${this.price} den.`
            }
            if (this.itemFiles[0]) {
              item.file = this.itemFiles[0]
              item.resourceSize = this.itemFiles[0].size
              this.sizeOfResource = this.itemFiles[0].size
              this.nameOfResource = this.itemFiles[0].name
            } else if (this.propItem) {
              if (this.propItem.resourceSize) {
                item.resourceSize = this.propItem.resourceSize
                this.globalLogger('resSize', this.propItem.resourceSize)
              }
            }
            if (this.propItem) {
              this.globalLogger('here 3')
              item.imageUrl = this.propItem.imageUrl
              this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem)
            } else {
              this.propParentFn(item, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource, this.sizeMinus)
            }
            this.$parent.close()
          }
        }
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/menu/items/MenuItemAddEdit.vue